<template>
  <v-card
    elevation="2"
    color="background"
    class="d-flex flex-column"
    style="height: 100%"
  >
    <v-card-title>
      المستخدمين
      <v-spacer></v-spacer>

      <DefaultDialog
        :showAddButton="isCanCreate"
        buttonText="اضافة"
        title="اضافة مستخدم"
        :openToEdit="openToEdit"
        editTitle="تعديل مستخدم"
        :openToView="openToView"
        viewTitle="عرض البيانات"
        @onCloseDialog="onCloseDialog"
      >
        <UserAdd
          slot-scope="{
            submitWithClose,
            submitWithNew,
            submitWithoutClose,
            closeDialog,
            isEdit,
            isView,
            isNew,
          }"
          :submitWithClose="submitWithClose"
          :submitWithNew="submitWithNew"
          :submitWithoutClose="submitWithoutClose"
          :setItemID="setItemID"
          :closeDialog="closeDialog"
          :isEdit="isEdit"
          :isView="isView"
          :isNew="isNew"
          :afterSubmit="getUsers"
          :itemId="itemId"
        />
      </DefaultDialog>

      <RolePermissionAddDialog
        v-model="rolePermissionAddDialog"
        :afterSubmit="() => {}"
      />
    </v-card-title>

    <v-card-text
      class="d-flex flex-column justify-space-between"
      style="flex: 1; min-height: 0"
    >
      <!-- Filters -->
      <v-row class="flex-grow-0">
        <v-col cols="12" class="d-flex align-center">
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="filters.filter"
            flat
            hide-details="auto"
            label="بحث"
            outlined
            prepend-inner-icon="mdi-magnify"
            solo
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- Grid -->
      <v-row class="mt-0" style="min-height: 0">
        <v-col cols="12" style="flex: auto; min-height: 0; height: 100%">
          <v-data-table
            class="elevation-1"
            :headers="headers"
            :items="navTypes"
            :items-per-page="options.pageSize"
            :loading="$store.state.loading.show"
            :ripple="false"
            fixed-header
            hide-default-footer
            height="100%"
            style="height: 100%; overflow: auto"
            loading-text="جار التحميل..."
            no-data-text="لا يوجد"
          >
            <template v-slot:[`item.isActive`]="{ item }">
              <v-simple-checkbox
                v-model="item.isActive"
                disabled
              ></v-simple-checkbox>
            </template>

            <template v-slot:[`item.creationTime`]="{ item }">
              <span dir="ltr">{{
                $service.formatDate(item.creationTime)
              }}</span>
            </template>

            <template v-slot:[`item.controls`]="props">
              <v-btn
                v-if="isCanRead"
                small
                color="#78b200"
                @click="viewRow(props.item)"
                class="mr-1"
              >
                <v-icon color="#fff">mdi-eye</v-icon>
              </v-btn>

              <v-btn
                v-if="isCanUpdate"
                small
                color="#ffa000"
                @click="editRow(props.item)"
                class="mr-1"
              >
                <v-icon color="#fff">mdi-pencil-outline</v-icon>
              </v-btn>

              <v-btn
                v-if="isCanManagePermissions"
                small
                color="primary lighten-2"
                @click="
                  rolePermissionAddDialog.editRow({
                    name: 'U',
                    key: props.item.id,
                  })
                "
                class="mr-1"
              >
                <v-icon color="#fff">mdi-check-all</v-icon>
              </v-btn>

              <template v-if="isCanDelete">
                <v-btn
                  small
                  color="pink"
                  @click="deleteUser(props.item)"
                  class="mr-1"
                >
                  <v-icon color="#fff">mdi-delete</v-icon>
                </v-btn>
              </template>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <!-- pagination -->
      <v-row class="mt-0" style="flex: 0">
        <v-col cols="12" class="d-flex justify-space-between align-center">
          <v-pagination
            v-model="options.pageIndex"
            :length="numberOfPages"
            total-visible="7"
          />
          <v-select
            v-model="options.pageSize"
            :items="[5, 10, 15, 20]"
            label="عدد الصفوف"
            solo
            dense
            hide-details="auto"
            item-color="white"
            class="flex-grow-0"
            style="width: 100px"
          ></v-select>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import qs from 'qs';
import DefaultDialog from '@/components/DefaultDialog.vue';
import UserAdd from './curd/UserAdd.vue';
import { showSnackbarFailMessage } from '@/utls/snackbar';
import RolePermissionAddDialog from '@/views/roles/dialog/RolePermissionAddDialog.vue';
import { appPermissions } from '@/libs/auth/permissions/appPermissions';
import PermissionMixin from '@/mixins/PermissionMixin';
import { mapActions } from 'vuex';

const initFilters = {
  filter: '',
};

const initOptions = {
  pageIndex: 1,
  pageSize: 15,
  sorting: 'userName',
  ...initFilters,
};

export default {
  components: {
    UserAdd,
    DefaultDialog,
    RolePermissionAddDialog,
  },
  mixins: [PermissionMixin(appPermissions.users)],
  data() {
    return {
      rolePermissionAddDialog: {},
      sel: null,
      navTypes: [],
      total: 1,
      headers: [
        { text: 'اسم المستخدم', value: 'userName' },
        { text: 'الايميل', value: 'email' },
        // { text: 'الرقم', value: 'phoneNumber' },
        { text: 'تاريخ الاضافة', value: 'creationTime' },
        { text: 'نشط', value: 'isActive' },
        { text: '', value: 'controls', sortable: false },
      ],
      options: { ...initOptions },
      filters: { ...initFilters },
      // for view edit and detail
      // ------------------------
      openToEdit: false,
      openToView: false,
      itemId: null,
      // ------------------------
    };
  },
  computed: {
    skipPerPage() {
      return this.options.pageSize * (this.options.pageIndex - 1);
    },
    numberOfPages() {
      const pages = Math.ceil(this.total / this.options.pageSize) || 1;
      return pages;
    },
  },
  created() {
    this.getUsers();
  },
  methods: {
    ...mapActions('confirm', ['openConfirm']),
    onCloseDialog() {
      this.openToEdit = false;
      this.openToView = false;
    },
    editRow(item) {
      this.openToEdit = true;
      this.itemId = item.id;
    },
    viewRow(item) {
      this.openToView = true;
      this.itemId = item.id;
    },
    setItemID(id) {
      if (id) return this.editRow({ id });
      this.itemId = null;
      this.onCloseDialog();
    },
    deleteUser(item) {
      this.openConfirm({
        message: `هل انت متأكد من حذف المسستخدم ؟`,
        confirm: () => {
          return this.$http
            .delete('identity/users/' + item.id, {})
            .then(() => {
              this.getUsers();
              return true;
            })
            .catch((error) => {
              showSnackbarFailMessage('حدث خطأ اثناء عملية الحذف');
              return false;
            });
        },
      });
    },
    getUsers() {
      this.$store.commit('loading/SET_SHOW', true);

      const requestConfig = {
        params: {
          skipCount: this.skipPerPage,
          maxResultCount: this.options.pageSize,
          sorting: this.options.sorting,
          filter: this.filters.filter,
        },
        paramsSerializer: function (params) {
          const queryString = qs.stringify(params, { arrayFormat: 'brackets' });
          return queryString;
        },
      };

      this.$http
        .get('identity/users', requestConfig)
        .then((response) => {
          const { items, totalCount } = response.data;
          this.navTypes = items;
          this.total = totalCount;
        })
        .catch((error) => {
          showSnackbarFailMessage('حدث خطأ اثناء عملية جلب البيانات');
        })
        .finally(() => this.$store.commit('loading/SET_SHOW', false));
    },
    searchUser() {},
  },
  watch: {
    options: {
      handler() {
        this.getUsers();
      },
      deep: true,
    },
    'filters.filter': {
      handler() {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(
          () => Object.assign(this.options, this.filters),
          500,
        );
      },
      deep: true,
    },
  },
};
</script>
